var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useRef, useState } from "react";
import Text from "../../../text/Text";
import NewCustomerRegistrationForm from "../../../form/NewCustomerRegistrationForm";
import Modal from "../../../modal/Modal";
import FavoritesBrowserStorageService from "./FavoritesBrowserStorageService";
import { useFavorites } from "./useFavorites";
var FavoriteContainer = function (_a) {
    var children = _a.children;
    var _b = useFavorites(), addFavorite = _b.addFavorite, removeFavorite = _b.removeFavorite, isProductOnFavorites = _b.isProductOnFavorites;
    var _c = useState(FavoritesBrowserStorageService.getCustomerId()), customerId = _c[0], setCustomerId = _c[1];
    var _d = useState(false), isGuestModalOpen = _d[0], setGuestModalOpen = _d[1];
    var _e = useState(false), customerCreated = _e[0], setCustomerCreated = _e[1];
    var promise = useRef();
    var addProduct = useCallback(function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var cid, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!customerId) return [3, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4, openModal()];
                case 2:
                    cid = _a.sent();
                    return [2, addFavorite(cid, productId)];
                case 3:
                    e_1 = _a.sent();
                    throw e_1;
                case 4:
                    promise.current = undefined;
                    return [7];
                case 5: return [2, addFavorite(customerId, productId)];
            }
        });
    }); }, [customerId, addFavorite]);
    var removeProduct = useCallback(function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var cid, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!customerId) return [3, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4, openModal()];
                case 2:
                    cid = _a.sent();
                    return [2, removeFavorite(cid, productId)];
                case 3:
                    e_2 = _a.sent();
                    throw e_2;
                case 4:
                    promise.current = undefined;
                    return [7];
                case 5: return [2, removeFavorite(customerId, productId)];
            }
        });
    }); }, [customerId, removeFavorite]);
    var openModal = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setGuestModalOpen(true);
            return [2, new Promise(function (resolve, reject) {
                    promise.current = { resolve: resolve, reject: reject };
                })];
        });
    }); };
    var closeModal = function () {
        var _a;
        setGuestModalOpen(false);
        (_a = promise === null || promise === void 0 ? void 0 : promise.current) === null || _a === void 0 ? void 0 : _a.reject();
    };
    var handleNewCustomerSuccess = function () {
        var _a;
        var cid = FavoritesBrowserStorageService.getCustomerId();
        if (cid) {
            setCustomerId(cid);
            (_a = promise === null || promise === void 0 ? void 0 : promise.current) === null || _a === void 0 ? void 0 : _a.resolve(cid);
            setCustomerCreated(true);
        }
    };
    return (React.createElement(React.Fragment, null,
        children({ addProduct: addProduct, removeProduct: removeProduct, isProductOnFavorites: isProductOnFavorites }),
        React.createElement(Modal, { title: "Add to favorites", "aria-describedby": "favoritesModalDescription", isOpen: isGuestModalOpen, onRequestClose: closeModal },
            !customerCreated && (React.createElement(React.Fragment, null,
                React.createElement(Text, { as: "p", mb: 2, display: "block", id: "favoritesModalDescription" }, "Sign up now to add this item to your favorites."),
                React.createElement(Text, { as: "p", mb: 5, display: "block" },
                    "Already have an account?",
                    " ",
                    React.createElement("a", { href: "/cart/logoff.php?next=".concat(encodeURIComponent(window.location.pathname)), style: { fontWeight: "bold", textDecoration: "underline" } }, "Sign in")))),
            React.createElement(NewCustomerRegistrationForm, { includeEmailConfirmation: false, includePasswordFields: false, successMessage: "Your account was successfully created and this item was saved to your favorites.", onSuccess: handleNewCustomerSuccess, onClose: closeModal, location: "Add Favorite Modal" }))));
};
export default FavoriteContainer;
//# sourceMappingURL=FavoriteContainer.js.map